import React from 'react';
import { offerRows } from '../data/content';
import { CtaButton } from './CtaButton';
export function Offer() {
  return <section id="offer" className="w-full bg-white px-5 py-20 sm:py-28" data-id="element-125" data-mp="17xuswfmwwmsb">
      <div className="mx-auto max-w-md" data-id="element-126" data-mp="1mo2182j7gpfa">
        <h2 className="text-center font-display text-[1.6rem] font-black leading-tight tracking-tight text-ink sm:text-[2.2rem]" data-id="element-127" data-mp="1mmqz075erpqa">
          <span aria-hidden="true" data-id="element-128" data-mp="tyv5tcf1sfy9">🏆 </span>Special Launch Offer
        </h2>

        <div className="relative mt-10 rounded-3xl border-2 border-brand bg-white px-7 pb-8 pt-11 shadow-soft" data-id="element-129" data-mp="u0xsbmgzrqy8">
          <span className="absolute -top-3 left-1/2 -translate-x-1/2 rounded-full bg-brand px-4 py-1.5 text-[10px] font-extrabold uppercase tracking-[0.14em] text-white" data-id="element-130" data-mp="p24ratiw5sey">
            ESL READY™ Pack
          </span>

          <dl data-id="element-131" data-mp="2fbxvz1p7s79f">
            {offerRows.map(row => <div key={row.label} className="flex items-center justify-between gap-4 border-b border-ink/10 py-4 text-sm" data-id="element-132" data-mp="2fad1fc2wgobk">
                <dt className="text-ink/80" data-id="element-133" data-mp="pj5ssivaq8bd">{row.label}</dt>
                <dd className="font-bold text-brand" data-id="element-134" data-mp="ujbme4l4m4w3">{row.value}</dd>
              </div>)}
            <div className="flex items-center justify-between border-b border-ink/10 py-4 text-sm" data-id="element-135" data-mp="zieslscueh5n">
              <dt className="font-bold uppercase tracking-wide text-ink" data-id="element-136" data-mp="13k05hdpdmvfu">
                Total Value:
              </dt>
              <dd className="font-bold text-amber-600 line-through" data-id="element-137" data-mp="6uiow3ouvozd">
                $225 USD
              </dd>
            </div>
          </dl>

          <p className="mt-6 text-center text-[11px] font-extrabold uppercase tracking-[0.16em] text-brand" data-id="element-138" data-mp="bt2eqf6klkx0">
            Today only
          </p>
          <p className="flex items-center justify-center gap-2 border-b border-ink/10 pb-7 pt-2" data-id="element-139" data-mp="klntlk72z7gk">
            <span className="text-4xl leading-none" aria-hidden="true" data-id="element-140" data-mp="3k95m0jtrt7kt">
              🏆
            </span>
            <span className="font-display text-6xl font-black leading-none text-brand" data-id="element-141" data-mp="3o9fnbj6mb9tc">
              $19
            </span>
            <span className="self-end pb-2 text-sm font-bold text-brand" data-id="element-142" data-mp="ve624bcshrtt">
              USD
            </span>
          </p>

          <p className="mt-5 text-center text-[11px] font-medium leading-relaxed text-ink/60" data-id="element-143" data-mp="qejo3zp507jy">
            <span aria-hidden="true" data-id="element-144" data-mp="157murc16x0vw">💳 </span>Payment will be processed in your
            local currency (or the equivalent of 19 USD).
          </p>

          <CtaButton className="mt-4 w-full" data-id="element-145" data-mp="cg397lh4faqq" />

          <p className="mt-4 text-center text-[11px] font-medium text-ink/50" data-id="element-146" data-mp="ciz6d7l59ve4">
            Instant Download · One-Time Payment · Lifetime Access · 7-Day
            Guarantee
          </p>
        </div>
      </div>
    </section>;
}